export default __webpack_public_path__ + "img/ce158936eaf4b603735ce431f68605e8.png";